import Compressor from 'compressorjs'

export const uploadImage = (e) => {
    return new Promise((resolve, reject) => {
        if (e.target.files.length < 1){
            resolve( {
                file: null,
                preview: null
            } );
        }
        
        const image = e.target.files[0]
        new Compressor(image, {
            quality: 0.6,
            maxHeight: 1024,
            maxHeight: 1024,
            convertSize: 2000000,
            success(result) {
                const reader = new FileReader();
                reader.readAsDataURL(result)
                reader.onload = e => {
                    resolve({
                        file: result,
                        preview: e.target.result,
                    })
                }
            }
        })
    })
}